module.exports = __webpack_public_path__ + "static/media/convoBg.6da7d68f.jpg";